var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"headers":_vm.headers,"endpoint":_vm.endpoint,"fields":_vm.fields,"filters":_vm.filters,"actions":['pdf-button'],"title":_vm.$t('invoices-vendor'),"file-name":_vm.fileName,"modal":_vm.modal,"show-search":""}})}
var staticRenderFns = []

export { render, staticRenderFns }